export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            dancer_route: dancerRoute(entity),
        };
    }

    async function get(idDancer) {
        let dancer = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('dancers/' + idDancer);
            dancer = build(data.dancer);
        } catch (e) {
            error = useApiError(e);
        }
        return {dancer, error};
    }

    async function post(params) {
        let dancer = null,
            error = null;
        try {
            const {data} = await useApi('videos').post('dancers', params);
            dancer = build(data.dancer);
        } catch (e) {
            error = useApiError(e);
        }
        if (!dancer) dancer = params;
        return {dancer, error};
    }

    async function put(idDancer, params) {
        let dancer = null,
            error = null;
        try {
            const {data} = await useApi('videos').put('dancers/' + idDancer, params);
            dancer = build(data.dancer);
        } catch (e) {
            error = useApiError(e);
        }
        if (!dancer) dancer = params;
        return {dancer, error};
    }

    async function remove(idDancer) {
        let error = null;
        try {
            await useApi('videos').delete('dancers/' + idDancer);
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    function dancerRoute(entity) {
        if (!entity.id_dancer) return undefined;
        return {
            name: 'dancers-idDancer',
            params: {
                idDancer: entity.id_dancer,
            },
        };
    }

    return {build, get, post, put, remove};
}
